import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchPartnerScholarships} from 'shared/college-profile/actions/college-profile';

// component
import Congrats from './Congrats';

const mapStateToProps = ({college, student}) => ({
  schoolId: student.currentInstitution ? student.currentInstitution.schoolId : null,
  partnerScholarships: college.partnerScholarships || null,
  college,
  student,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchPartnerScholarships,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Congrats);
